/**
 * Backwards-compatibility shim.
 *
 * The original `ErrorReportDialog` has been replaced by the three-lane
 * `FeedbackDialog`. Existing call sites (error boundary, chat-response error,
 * chat "Report Issue" button) keep working through this shim, which maps the
 * old prop shape to the new dialog. New code should import `FeedbackDialog`
 * directly from `@/components/feedback-dialog`.
 *
 * TODO: remove this file once all call sites have been migrated to
 * `FeedbackDialog`.
 */

import { FeedbackDialog } from "@/components/feedback-dialog"

type ErrorReportDialogProps = {
  reportType?: "error" | "response_issue"
  errorId?: string
  sessionId?: string
  messageId?: string
  responseContent?: string
  trigger?: React.ReactNode
  hideTrigger?: boolean
  open?: boolean
  onOpenChange?: (open: boolean) => void
}

export function ErrorReportDialog({
  reportType = "error",
  errorId,
  sessionId,
  messageId,
  responseContent,
  trigger,
  hideTrigger = false,
  open,
  onOpenChange,
}: ErrorReportDialogProps) {
  const isResponseIssue = reportType === "response_issue"
  return (
    <FeedbackDialog
      lockLane
      hideTrigger={hideTrigger}
      initialLane={isResponseIssue ? "response_feedback" : "bug"}
      initialSentiment={isResponseIssue ? "down" : undefined}
      open={open}
      trigger={trigger}
      prefillContext={{
        errorId: errorId ?? null,
        sessionId: sessionId ?? null,
        messageId: messageId ?? null,
        responseContent: responseContent ?? null,
      }}
      onOpenChange={onOpenChange}
    />
  )
}
